import { AxiosResponse } from 'axios';
import api from './Api'

export const getIssuedYogaCouponById = (id: string): Promise<AxiosResponse<any, any>> => {
    return api.get(`/issued-yoga-coupon/mobile/${id}`)
}

export const getAllAvailableIssuedYogaCouponByMemberIdAndWellnessTicketId = (wellnessTicketId: string): Promise<AxiosResponse<IAvailableIssuedYogaCoupon[], any>> => {
    return api.get(`/issued-yoga-coupon/web/wellness-ticket/v2/${wellnessTicketId}`)
}